import { RestService } from "./rest/rest.service";
import { BehaviorSubject } from "rxjs";
import { Injectable } from "@angular/core";
import { urlConfig } from "../../../config/url.config";
import { ROUTES } from "../utils/routes";
import { PageService } from "./page.service";

@Injectable()
export class CaptchaService {
    $enableInvisibleCaptcha = new BehaviorSubject<boolean>(false);
    $enableVisibleCaptcha = new BehaviorSubject<boolean>(false);
    $isComponentCaptchaVisible = new BehaviorSubject<boolean>(false);
    $captchaValidated = new BehaviorSubject<boolean>(false);

    constructor(
        private pageService: PageService,
        private restService: RestService
    ) {}

    loadScriptCaptcha(countOfTries: number = 0) {
        this.pageService.isPageLoading = true;
        this.pageService.updateValues({
            subtitle: "Preparando validação de segurança.",
        });

        const mainCaptcha = document.createElement("script");
        const polyfills = document.createElement("script");

        polyfills.src = urlConfig.base.urlCaptchaElement + "/polyfills.js";
        document.getElementsByTagName("head")[0].appendChild(polyfills);

        mainCaptcha.src = urlConfig.base.urlCaptchaElement + "/main.js";
        document.getElementsByTagName("head")[0].appendChild(mainCaptcha);

        mainCaptcha.onerror = () => {
            mainCaptcha.remove();
            setTimeout(() => {
                if (countOfTries < 4) {
                    this.pageService.updateValues({
                        title: "Carregando",
                        subtitle: "Aguarde mais alguns instantes ...",
                    });
                    this.loadScriptCaptcha(countOfTries + 1);
                } else {
                    this.goToError();
                }
            }, 100);
        };

        document.body.append(mainCaptcha);
    }

    private showVisibleCaptcha() {
        this.$isComponentCaptchaVisible.next(true);
    }

    private hideVisibleCaptcha() {
        this.$isComponentCaptchaVisible.next(false);
    }

    validateCaptcha(token: string, version: string) {
        this.restService.validateCaptcha(token, version).subscribe(
            () => {
                this.hideVisibleCaptcha();
                this.$captchaValidated.next(true);
            },
            (error) => {
                if (error.type === "invisible") {
                    this.$captchaValidated.next(false);
                    this.$enableVisibleCaptcha.next(true);
                    this.$enableInvisibleCaptcha.next(false);
                    this.showVisibleCaptcha();
                    this.moveVisibleCaptchaElement();
                } else {
                    this.hideVisibleCaptcha();
                    this.goToError();
                }
            }
        );
    }

    private goToError() {
        this.pageService.goToPage(ROUTES.errorGeneric.url);
    }

    private moveVisibleCaptchaElement() {
        setTimeout(() => {
            const placeholder = document.getElementById(
                "captchaVisiblePlaceholder"
            );
            const elementCaptcha = document.getElementById("elementCaptcha");
            if (placeholder && elementCaptcha)
                elementCaptcha.classList.add("show");
            placeholder.append(elementCaptcha);
            placeholder.classList.add("with-captcha");
        }, 100);
    }
}
